"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Section["default"];
  }
});
var _Section = _interopRequireDefault(require("./Section"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }